import { render, staticRenderFns } from "./InspectList.vue?vue&type=template&id=f6af9dc6&scoped=true"
import script from "./InspectList.vue?vue&type=script&lang=js"
export * from "./InspectList.vue?vue&type=script&lang=js"
import style0 from "./InspectList.vue?vue&type=style&index=0&id=f6af9dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af9dc6",
  null
  
)

export default component.exports